import React, { useState } from 'react';
import OtpInput from 'react-otp-input';
import toastMessageServiceSingleton from 'src/services/toast-message.service';
import { InputErrorIcon } from 'src/assets/images';
import './salesforce-validate-otp-form.scss';

export default function SalesforceValidateOtpForm({
  otpEmailAddress,
  resendOtp,
  submitOtp,
  onOtpResendButtonClick,
  onOtpValidateButtonClick,
  onOtpIncorrect,
  onOtpExpired,
  onOtpAttemptsExceeded,
  onTechnicalError,
  onOtpValidationSuccessful,
  automationIdPrefix,
}) {
  const otpLength = 6;
  const otpTriesMax = 3;
  const [otp, setOtp] = useState('');
  const [otpError, setOtpError] = useState('');
  const [userStartedNewOtpAfterError, setUserStartedNewOtpAfterError] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [otpTries, setOtpTries] = useState(0);
  const otpTriesExceeded = () => otpTries >= otpTriesMax;
  const [otpExpired, setOtpExpired] = useState(false);

  const handleIncorrectOTPError = () => {
    const otpRetriesCurrent = otpTries + 1;
    setOtpTries(otpRetriesCurrent);

    if (otpRetriesCurrent >= otpTriesMax) {
      const errorMsg = `You’ve exceeded the OTP attempts. Please try again later`;
      setOtpError(errorMsg);
      setUserStartedNewOtpAfterError(false);
      onOtpAttemptsExceeded(errorMsg);
    } else {
      const errorMsg = `Incorrect OTP - Try again ${otpRetriesCurrent}/${otpTriesMax}`;
      setOtp('');
      setOtpError(errorMsg);
      setUserStartedNewOtpAfterError(false);
      onOtpIncorrect(errorMsg);
    }
  };

  const handleExpiredOTPError = () => {
    setOtpExpired(true);
    const errorMsg = 'Your OTP has expired. Please request a new OTP';
    setOtp('');
    setOtpError(errorMsg);
    setUserStartedNewOtpAfterError(false);
    onOtpExpired(onOtpExpired);
  };

  const submitFormOtp = async () => {
    onOtpValidateButtonClick();
    setSubmitting(true);
    const { result, error } = await submitOtp(otp);

    switch (error) {
      case null:
        onOtpValidationSuccessful(result);
        break;
      case 'OTP code is incorrect.':
        handleIncorrectOTPError();
        break;
      case 'OTP code is to old.':
        handleExpiredOTPError();
        break;
      default:
        onTechnicalError('unrecognized error received in response to OTP get request');
        break;
    }

    setSubmitting(false);
  };

  const resendFormOtp = async () => {
    onOtpResendButtonClick();
    setOtp('');
    setOtpTries(0);
    setOtpError('');
    setOtpExpired(false);
    toastMessageServiceSingleton.addToast({
      message: `OTP resent to your email`,
      type: 'info',
    });
    await resendOtp();
  };

  return (
    <section className="salesforce-validate-otp-form">
      <div className="has-text-centered">
        <div className="heading-we-sent-you-an-email">We sent you an email</div>

        <p className="sub-heading-please-enter-otp">
          Please enter 6 digit verification code sent to{' '}
          <span className="bold">{otpEmailAddress}</span>
        </p>
      </div>

      <div className="otp-input-section" automationid={`${automationIdPrefix}_Div_Input`}>
        <OtpInput
          isInputNum={true}
          key={otpTries}
          shouldAutoFocus={true}
          isDisabled={otpTriesExceeded() || otpExpired}
          value={otp}
          onChange={(otp) => {
            setOtp(otp);
            setUserStartedNewOtpAfterError(true);
          }}
          numInputs={otpLength}
          containerStyle="otp-input-container has-margin-top-7"
          inputStyle={`otp-input ${otpError && !userStartedNewOtpAfterError ? 'error-style' : ''}`}
          autoFocus
        />

        <div className="field-error">
          {otpError && (
            <>
              <img className="error-image" src={InputErrorIcon} />
              <span>{otpError}</span>
            </>
          )}
        </div>
      </div>

      <div className="continue-button-otp">
        <button
          automationid={`${automationIdPrefix}_Button_Submit_OTP`}
          disabled={submitting || otp.length < otpLength || otpTriesExceeded()}
          className="button is-primary red-continue-button "
          onClick={() => {
            submitFormOtp(otp);
          }}
        >
          Continue
        </button>
      </div>
      <div className="otp-not-received-yet">
        <span className="request-reset-left">Haven't received OTP yet?</span>
        &nbsp;
        <span className="line-break">
          <br />
        </span>
        <span
          className={`request-new-otp ${otpTriesExceeded() ? 'otp-tries-exceeded' : ''}`}
          onClick={async () => !otpTriesExceeded() && resendFormOtp()}
        >
          Request new OTP
        </span>
      </div>
    </section>
  );
}
